<script lang="ts" setup>
const { initTheme } = useLayout()
const { siteName } = useSite()

onBeforeMount(() => {
  initTheme()
})

useHead({
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${titleChunk} | ${siteName.value}` : siteName.value
  },
})
</script>

<template>
  <FloatingConfigurator />

  <div class="flex items-center justify-center min-h-screen">
    <div class="bg-white p-5 rounded-lg shadow w-72 dark:bg-surface-800">
      <NuxtPage />
    </div>
  </div>
  <Toast />
</template>
